export default __webpack_public_path__ + "static/poster-dc4ab71ca8c5a9289dbc8c0d6eabed64.png";